
import {PolyCord} from "../Polystr"

// selectedfeature

export function MapTerrain(map,pitch){
  if (pitch ===0){
    return
  }
  else{
    const source_id = "mapbox-dem"
    const layer_id =  "sky"
    const visibility = 'visible'
   
    if (map) {

      if (map.getLayer(layer_id)) {
          map.removeLayer(layer_id);
        }
      if (map.getSource(source_id)) {
           map.removeSource(source_id);
        }
      
          map.addSource('mapbox-dem', {
            'type': 'raster-dem',
            'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
            'tileSize': 256
            });
        map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1.5 });
        map.addLayer({
            'id': 'sky',
            'type': 'sky',
            'paint': {  
            'sky-type': 'atmosphere',
            'sky-atmosphere-sun': [0.0, 90.0],
            'sky-atmosphere-sun-intensity': 15
            }
            });
    }
  }
    
  }








